export default (value) => {
	return Math.round(value)
}



// WEBPACK FOOTER //
// ./src/filters/global/round.js